import React from 'react';
import BusinessModelFirst from './BusinessModelFirst';
import BusinessModelSecond from './BusinessModelSecond';
import SEOHead from '../../seo/SEOHead';
import { seoConfig } from '../../seo/seoConfig';
import { generateBreadcrumbs } from '../../seo/structuredData';

const BusinessModel: React.FC = () => {
  return (
    <div className="business-model">
      <SEOHead
        {...seoConfig.modell}
        structuredData={generateBreadcrumbs([
          { name: 'Home', url: 'https://www.styror.com/' },
          { name: 'Recycling-Prozess', url: 'https://www.styror.com/modell' },
        ])}
      />
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
        Unser Recycling-Prozess – So funktioniert EPS Verwertung
      </h1>
      <BusinessModelFirst />
      <BusinessModelSecond />
    </div>
  );
};

export default BusinessModel;